(function () {
  const KEY = '_igShowShippingPromise';
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      if (cart.attributes && cart.attributes[KEY] === 'true') return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [KEY]: 'true' } }),
      });
    })
    .catch(() => {});
})();